import { render, staticRenderFns } from "./FormAgenda.vue?vue&type=template&id=dce1a47e&scoped=true"
import script from "./FormAgenda.vue?vue&type=script&lang=js"
export * from "./FormAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce1a47e",
  null
  
)

export default component.exports